import { cx, getColor } from "@/utils";

import styles from "./Avatar.module.css";

const Avatar = ({
  full_name = "",
  first_name = "",
  last_name = "",
  className,
  size = 24,
  ...props
}: {
  full_name: string;
  first_name: string;
  last_name: string;
  className?: string;
  size?: number;
}) => {
  const color = getColor(0, {
      // weird auto typings here ....
      scope: "user" as unknown as null,
      title: full_name as unknown as null,
      dark: true,
    }),
    style = {
      backgroundColor: color,
      height: size,
      width: size,
      fontSize: size * 0.4,
    };
  if (!first_name || !last_name) {
    return null;
  }
  const initials = `${first_name[0]}${last_name[0]}`;

  return (
    <span {...props} style={style} className={cx(styles.root, className)}>
      {initials}
    </span>
  );
};

export default Avatar;
